import React from 'react';
import { useHapticFeedback } from '@bitbot/shared/bridge';
export default function HapticContainer({
  children,
  className,
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) {
  const hapticFeedBack = useHapticFeedback();
  return (
    <div
      onClick={() => {
        if (onClick) {
          onClick();
        }
        hapticFeedBack?.impactOccurred('light');
      }}
      className={className}
    >
      {children}
    </div>
  );
}
